<div style="display: none">Разработка сайта — ООО НПО "Панцирь", {{ currentYear }}</div>

<tui-root>
  <router-outlet></router-outlet>
</tui-root>
@if (crm2ChatWidget.showLoader()) {
  <div class="crm2-loader" aria-hidden="true">
    <tui-loader size="m" />
  </div>
}

<app-data-collection-notice />
